export const CASH_ACCOUNT_OPTIONS = [
  { value: '', label: 'CASH Trust' },
  { value: 'cash_gpt_checking', label: 'CASH - GPT Checking' },
  { value: 'cash_gpt_new', label: 'CASH - GPT New' },
  { value: 'cash_gpt_old', label: 'CASH - GPT Old' },
  { value: 'cash_gsnt_new', label: 'CASH - GSNT New' },
  { value: 'cash_gsnt_old', label: 'CASH - GSNT Old' },
  { value: 'cash_gta', label: 'CASH - GTA' },
]

export const DEPOSIT_TYPE_OPTIONS = [
  { value: '', label: 'Choose Type' },
  { value: 'wire', label: 'Wire' },
  { value: 'check', label: 'Check' },
  { value: 'direct_deposit', label: 'Direct Deposit' },
]

export const BANK_ACCOUNTS = [
  { value: 'GPT_New_6497', label: 'GPT New *6497' },
  { value: 'GPT_Old_3289', label: 'GPT Old *3289' },
  { value: 'GPT_Old_Deposit_3297', label: 'Deposit Only *3297' },
  { value: 'GPT_Checking_6980', label: 'GPT Checking *6980' },
  { value: 'GTA_1813', label: 'GTA *1813' },
  { value: 'GSNT_New_5164', label: 'GSNT New *5164' },
  { value: 'GSNT_Old_3737', label: 'GSNT Old *3737' },
]

export const getQueueNameFromStatus = (status) => {
  const queueMapping = {
    received: 'receive',
    transferred: 'transfer',
    reviewed: 'review',
    deposited_today: 'deposited_today',
    reviewed_with_approved_edits: 'second_review',
    deposited: 'all',
    cash: 'cash',
    deleted: 'deleted',
  }
  return queueMapping[status] || 'main'
}
